import { render } from "./project-cmp.vue?vue&type=template&id=15554a5c&scoped=true"
import script from "./project-cmp.vue?vue&type=script&lang=js"
export * from "./project-cmp.vue?vue&type=script&lang=js"

import "./project-cmp.vue?vue&type=style&index=0&id=15554a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15554a5c"]])

export default __exports__